import { connect } from 'react-redux';

import { getCustomText, getUserName } from 'app/modules';
import PreIdentifiedUserWelcomeMessage from '../PreIdentifiedUserWelcomeMessage';
import replaceUserName from 'lib/replaceUserName';

export const mapStateToProps = state => {
  const customText = getCustomText(state);

  return {
    content: replaceUserName(getUserName(state), customText.preIdentifiedUserWelcomeMessage),
  };
};

const PreIdentifiedUserWelcomeMessageContainer = connect(mapStateToProps)(PreIdentifiedUserWelcomeMessage);

export default PreIdentifiedUserWelcomeMessageContainer;
